import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="w-full py-24 px-6 bg-[#0a0f0d]" data-id="element-76">
      <div className="max-w-2xl mx-auto space-y-24" data-id="element-77">
        {/* El Problema Real */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-bold text-[#f0f0f0]" data-id="element-79">
            El problema real{' '}
            <span className="text-gray-500 font-normal" data-id="element-80">(sin humo)</span>
          </h2>

          <div className="space-y-6 text-lg text-gray-400 leading-relaxed" data-id="element-81">
            <p data-id="element-82">El mercado de IA para marketing está saturado.</p>
            <p data-id="element-83">
              Lo que te venden: "domina IA", "1000 prompts", "resultados
              rápidos".
            </p>
            <p data-id="element-84">Lo que te pasa a ti:</p>
            <ul className="space-y-3 pl-4 border-l border-gray-800" data-id="element-85">
              <li data-id="element-86">— tienes demasiadas tareas</li>
              <li data-id="element-87">
                — intentas usar ChatGPT y te da "cosas" que no se sostienen
              </li>
              <li data-id="element-88">— te cansas, lo abandonas, vuelves a la operativa manual</li>
              <li data-id="element-89">
                — te queda la sensación de "quizá no soy lo suficientemente
                técnico"
              </li>
            </ul>
            <p className="text-xl text-white font-medium pt-4" data-id="element-90">No es eso.</p>
            <p data-id="element-91">
              Tu problema es que no tienes un{' '}
              <span className="text-[#00d4aa]" data-id="element-92">estándar</span>.
            </p>
            <p data-id="element-93">
              Un estándar es lo único que convierte la IA en un sistema usable.
            </p>
          </div>
        </motion.div>

        {/* Divider */}
        <div className="w-24 h-px bg-[#00d4aa]/30 mx-auto" data-id="element-94" />

        {/* La Idea Central */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-95">
          <h2 className="text-3xl md:text-4xl font-bold text-[#f0f0f0]" data-id="element-96">
            La idea central
          </h2>

          <div className="space-y-6 text-lg text-gray-400 leading-relaxed" data-id="element-97">
            <p className="text-xl text-white" data-id="element-98">
              Un asistente no es un prompt. Es un empleado digital.
            </p>
            <p data-id="element-99">Y un empleado digital no funciona con inspiración.</p>
            <p data-id="element-100">Funciona con:</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4" data-id="element-101">
              {['Información autorizada (inputs)', 'Límites claros (reglas)', 'Formatos de entrega (salidas)', 'Control de calidad (pruebas)'].map((item, i) => <div key={i} className="bg-[#050505] border border-gray-800 p-4 rounded text-center text-gray-300" data-id="element-102">
                  {item}
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}